'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContentRect = exports.default = undefined;

var _Measure = require('./Measure');

var _Measure2 = _interopRequireDefault(_Measure);

var _withContentRect = require('./with-content-rect');

var _withContentRect2 = _interopRequireDefault(_withContentRect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Measure2.default;
exports.withContentRect = _withContentRect2.default;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-measure/lib/react-measure.js
// module id = 798
// module chunks = 168707334958949